import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  packagingReturnsControllerCreate,
  PackagingReturnsControllerCreate$Params,
  packagingReturnsControllerFindAll,
  PackagingReturnsControllerFindAll$Params,
  packagingReturnsControllerFindById,
} from '@klubovna/api-client';
import { CreatePackagingReturnDto, PackagingReturn } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PackagingReturnsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: PackagingReturnsControllerFindAll$Params): Observable<PaginatedResponse<PackagingReturn>> {
    return packagingReturnsControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<PackagingReturn>(response.body)));
  }

  findById(id: string): Observable<PackagingReturn> {
    return packagingReturnsControllerFindById(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as PackagingReturn));
  }

  create(data: CreatePackagingReturnDto): Observable<PackagingReturn> {
    const params: PackagingReturnsControllerCreate$Params = { body: data };
    return packagingReturnsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as PackagingReturn));
  }
}
